import { gql } from "@apollo/client";

export const GET_ALL_GRUPO_PROFESIONALES = gql`
query GetAllGrupoProfesional {
    allGrupoProfesional{
            idGrupoProfesional,
            nombre
      }
}`;